<template>
    <section>
        <div class="row">
            <div class="col-12">
                <job-schedule-menu @menuOption="setMenuOption($event)"></job-schedule-menu>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <router-view />
            </div>
        </div>
    </section>
</template>

<script>
import JobScheduleMenu from '@/components/job/schedule/ScheduleMenu';

export default {
    components: {
        JobScheduleMenu
    }
}
</script>